import I18n from "i18n-js";
import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, Text } from "react-native";
import { connect } from "react-redux";

import fonts from "../constants/fonts";

class TimelineSection extends React.Component {
  static propTypes = {
    date: PropTypes.instanceOf(Date).isRequired
  };

  render() {
    const { date, themeColors } = this.props;

    return (
      <Text style={[styles.section, { color: themeColors.darkestPrimary }]}>
        {I18n.t("prixa.sessionOn", {
          date: I18n.l("date.prixa.default", date)
        })}
      </Text>
    );
  }
}

const styles = StyleSheet.create({
  section: {
    fontSize: 16,

    ...fonts.regular
  }
});

export default connect(state => ({
  themeColors: state.themeColors
}))(TimelineSection);
